module.exports = __webpack_public_path__ + "img/IMG_5918.6f5d39c6.jpg";